import { resolveSupplierWidget } from './resolveSupplierWidget'
import { useCatalogItemCartContext } from '../../../../providers/CatalogItemCartProvider'
import { CatalogItemDetailsPanel } from '../../views/CatalogItemDetailsPanel'

export const CatalogItemDetailsPanelPresenter = () => {
  const {
    selectedItem,
    selectedItemDetails,
    quantity,
    estimatedTotal,
    changeQuantity,
    addToRequest,
    askFollowUp,
    collapse,
  } = useCatalogItemCartContext()

  if (!selectedItem) return null

  const supplierWidget = resolveSupplierWidget(
    selectedItem,
    selectedItemDetails
  )

  return (
    <CatalogItemDetailsPanel
      item={selectedItem}
      supplierWidget={supplierWidget}
      quantity={quantity}
      estimatedTotal={estimatedTotal}
      onQuantityChange={changeQuantity}
      onAddToRequest={addToRequest}
      onChipSelect={askFollowUp}
      onCollapse={collapse}
    />
  )
}
